export const NEW_DATA_LOADING = "NEW_DATA_LOADING";
export const NEW_DATA_SUCCESS = "NEW_DATA_SUCCESS";
export const NEW_DATA_FAILED = "NEW_DATA_FAILED";
export const NEW_DATA_CLEAR = "NEW_DATA_CLEAR";
export const NEW_TEST_DATA_SUCCESS = "NEW_TEST_DATA_SUCCESS";
export const NEW_TEST_DATA_CLEAR = "NEW_TEST_DATA_CLEAR";
export const SET_BACK_TO_OLD_UI_MESSAGE = "SET_BACK_TO_OLD_UI_MESSAGE";
export const RESET_BACK_TO_OLD_UI_MESSAGE = "RESET_BACK_TO_OLD_UI_MESSAGE";
